import { render, staticRenderFns } from "./CreateNewResourceCard.vue?vue&type=template&id=4cd3b180&scoped=true&"
import script from "./CreateNewResourceCard.vue?vue&type=script&lang=js&"
export * from "./CreateNewResourceCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewResourceCard.vue?vue&type=style&index=0&id=4cd3b180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd3b180",
  null
  
)

export default component.exports